<div class="app-wrapper theme-{{ theme | async }}">
  <router-outlet></router-outlet>
</div>

@defer {
  <lazy-sprite-sheet [spriteSheet]="spriteSheet.value()" />
}
